import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSourceCard } from '../../models/data-connection';
import { DataSourceCards } from '../../models/connection-dataset';
import { ConnectionType } from '../../../../API';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-create-data-connection',
  templateUrl: './create-data-connection.component.html',
  styleUrls: ['./create-data-connection.component.scss'],
})
export class CreateDataConnectionComponent {
  stepper: number = 0;
  selectedDatasource?: DataSourceCard | null;
  connectionDetailsText: string = 'Connection Details';
  isEditConnection: boolean = false;
  cardDetails: DataSourceCard[] = DataSourceCards;

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    public appService: AppService,
  ) {
    const url = this.router.url;
    const connectionId = this.activateRoute.snapshot.paramMap.get('connectionId');
    this.appService.dataConnectionHeader = 'Create Data Connection';

    if (url.startsWith('/data-connection-mapping')) {
      this.stepper = 3;
    } else if (url.startsWith('/data-connection') && connectionId) {
      this.isEditConnection = true;
      this.appService.dataConnectionHeader = 'Edit Data Connection';
      this.selectedDatasource = this.cardDetails.find((card) => card.key === ConnectionType.SFTP);
      this.stepper = 1;
    }
  }

  onDatasourceSelect(datasource: { selectedDatasource: DataSourceCard; stepper: number }): void {
    this.selectedDatasource = datasource.selectedDatasource;
    if (datasource.stepper) {
      this.stepper = 1;
    }
  }

  onBack(): void {
    if (this.isEditConnection) {
      this.router.navigate([`/data-connection`]);
    }
    this.stepper = 0;
    this.selectedDatasource = null;
  }
}
